import { autostart } from "./autostart";
import { kioskApps } from "./kioskApps";
import { kioskExitPassword } from "./kioskExitPassword";
import { kioskMode } from "./kioskMode";
import { screenRotation } from "./screenRotation";
import { screenTimeout } from "./screenTimeout";
import { stayAwakeWhileCharging } from "./stayAwakeWhileCharging";

export default [screenRotation, kioskMode, kioskExitPassword, kioskApps, autostart, stayAwakeWhileCharging, screenTimeout];
